/* Lotte Laren — filters en sorteren op collectie- en zoekpagina's.
   Elke keuze laadt de pagina opnieuw met de juiste URL (filter.* / sort_by),
   zodat Shopify zelf filtert en sorteert. Betrouwbaarder dan het verversen via AJAX. */
(function () {
  if (window.__llFilters) return;
  window.__llFilters = true;

  var FORM = '[data-collection-filters-form]';
  var timer = null;

  function containerOf(el) {
    return el.closest('[data-section-type]') || document;
  }

  function currentSort() {
    return new URL(window.location.href).searchParams.get('sort_by') || '';
  }

  function buildUrl(container, sortValue) {
    var url = new URL(window.location.href);
    var params = url.searchParams;
    var keys = [];
    params.forEach(function (_, k) { keys.push(k); });
    var oldSort = params.get('sort_by') || '';
    keys.forEach(function (k) {
      if (k.indexOf('filter.') === 0 || k === 'page' || k === 'sort_by') params.delete(k);
    });

    var form = container.querySelector(FORM);
    if (form) {
      var min = form.querySelector('[data-field-price-min]');
      var max = form.querySelector('[data-field-price-max]');
      if (min && max) {
        if (min.value !== '' && max.value === '') max.value = max.placeholder;
        if (max.value !== '' && min.value === '') min.value = min.placeholder;
      }
      new FormData(form).forEach(function (value, key) {
        if (key.indexOf('filter.') === 0 && value !== '') params.append(key, value);
      });
      var range = form.querySelector('[data-se-min][data-se-max]');
      if (range) {
        var gte = params.get('filter.v.price.gte');
        var lte = params.get('filter.v.price.lte');
        if (gte !== null && lte !== null &&
            parseFloat(gte) <= parseFloat(range.getAttribute('data-se-min')) &&
            parseFloat(lte) >= parseFloat(range.getAttribute('data-se-max'))) {
          params.delete('filter.v.price.gte');
          params.delete('filter.v.price.lte');
        }
      }
    }

    var sort = sortValue != null ? sortValue : oldSort;
    if (sort) params.set('sort_by', sort);

    var qs = params.toString();
    return url.pathname + (qs ? '?' + qs : '');
  }

  function go(href, container) {
    clearTimeout(timer);
    var grid = container && container.querySelector && container.querySelector('[data-products-grid]');
    if (grid) grid.classList.add('is-loading');
    window.location.href = href;
  }

  function later(container) {
    clearTimeout(timer);
    timer = setTimeout(function () { go(buildUrl(container), container); }, 450);
  }

  /* Sorteren */
  document.addEventListener('click', function (e) {
    var sortLink = e.target.closest && e.target.closest('[data-sort-link]');
    if (sortLink) {
      e.preventDefault();
      e.stopPropagation();
      var c = containerOf(sortLink);
      go(buildUrl(c, sortLink.getAttribute('data-value') || ''), c);
      return;
    }

    /* Filter verwijderen / alles wissen / reset */
    var update = e.target.closest && e.target.closest('[data-filter-update-url]');
    if (update && update.getAttribute('href') && update.getAttribute('href').charAt(0) !== '#') {
      e.preventDefault();
      e.stopPropagation();
      var href = update.getAttribute('href');
      var s = currentSort();
      if (s && href.indexOf('sort_by=') === -1) href += (href.indexOf('?') > -1 ? '&' : '?') + 'sort_by=' + encodeURIComponent(s);
      go(href, containerOf(update));
    }
  }, true);

  /* Vinkjes (beschikbaarheid, kleur, maat, ...) en prijsvelden */
  document.addEventListener('input', function (e) {
    var el = e.target;
    if (!el.closest || !el.closest(FORM)) return;
    e.stopPropagation();
    if (el.type === 'checkbox' || el.type === 'radio') {
      go(buildUrl(containerOf(el)), containerOf(el));
    } else {
      later(containerOf(el));
    }
  }, true);

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el.closest || !el.closest(FORM)) return;
    if (el.type === 'number') {
      e.stopPropagation();
      later(containerOf(el));
    }
  }, true);

  /* Prijsschuifje losgelaten */
  document.addEventListener('theme:range:update', function (e) {
    var el = e.target;
    if (!el.closest || !el.closest(FORM)) return;
    e.stopPropagation();
    later(containerOf(el));
  }, true);
})();
